import React from "react";
import BusDetailsCard from "./BusDetailsCard";

export default function Bus2() {
  return (
    <BusDetailsCard
      busId="bus2"
      title="Bus 2 - Route Details"
      busName="Bus 2"
      vehicleNo="TN74B2234"
      backTo="/?buses=1"
    />
  );
}